import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (consumidores/specs antigos importavam estes nomes). */
export type OficioMedicoJob = ReportJob;
export type OficioMedicoJobStatus = JobStatus;

@Injectable({ providedIn: 'root' })
export class OficioMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'oficio-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.oficioMedico;
}
